import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuTooltipComponent } from './menuTooltip.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { PlPopoverModule } from '@app/components/pl-popover/pl-popover.module';

@NgModule({
  imports: [CommonModule, PlIconModule, PlPopoverModule],
  declarations: [MenuTooltipComponent],
  exports: [MenuTooltipComponent],
})
export class MenuTooltipModule {}
